import { createContext, useContext } from 'react';

import {
  type DropdownItems,
  type FilterItemType,
  type InferType,
  type Nullable,
  type Paths,
} from './types';

export interface FiltersContextValue<T extends object> {
  value: T;
  onChange: (path: Paths<T>, value: Nullable<InferType<T, Paths<T>>>) => void;
  onDirectChange: (
    path: Paths<T>,
    value: Nullable<InferType<T, Paths<T>>>,
  ) => void;
  onCommit: () => void;
  items: Record<Paths<T>, FilterItemType<T>>;
  dropdownItems: DropdownItems<T>;
  selectedFilters: Paths<T>[];
  onDelete: (item: Paths<T>) => void;
  onClearFilters: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FiltersContext = createContext<FiltersContextValue<any> | null>(
  null,
);

export function useFilters<T extends object>() {
  const ctx = useContext(FiltersContext) as FiltersContextValue<T>;
  if (!ctx) throw new Error('useFilters must be used within a FiltersProvider');
  return ctx;
}
